import { render, staticRenderFns } from "./DocumentsDialog.vue?vue&type=template&id=35432a94"
import script from "./DocumentsDialog.ts?vue&type=script&lang=ts&external"
export * from "./DocumentsDialog.ts?vue&type=script&lang=ts&external"
import style0 from "./DocumentsDialog.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports